import { mutatorAction } from "satcheljs";
import { StaffHubPanelViewStateBase } from "../schema/StaffHubPanelViewStateBase";

export default mutatorAction("SET_STAFFHUB_PANEL_ALERT_MESSAGE_TEXT",
    function setStaffHubPanelAlertMessageText(
        viewState: StaffHubPanelViewStateBase,
        alertMessageText: string) {
        viewState.panelAlertText = alertMessageText;
    });